'use strict';

require('../../style/index.less');

require('./index.less');

require('../../tooltip/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/slider/style/index.tsx
 ** module id = 798
 ** module chunks = 0
 **/